<script setup>
defineProps({
  hasGoldMethods: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <!--
    One plan, because Bindle sells one thing. This listed three and counted how
    many "tiers" an applicant had landed on, which was a question with only one
    possible answer long before the other two were retired.
  -->
  <section id="pricing-info" class="surface-card mb-6 p-6">
    <div id="multi-module-info">
      <div class="mb-6 flex items-start space-x-4">
        <div class="grid size-12 shrink-0 place-items-center rounded-xl bg-brand">
          <span class="material-symbols-outlined text-xl text-brand-contrast">layers</span>
        </div>
        <div>
          <h4 class="mb-2 text-lg font-bold text-ink">Your Pricing Plan</h4>
          <p v-if="hasGoldMethods" class="text-sm text-muted">
            Based on your selection, you'll be on <strong>1:1 Tutoring</strong>
          </p>
          <p v-else class="text-sm text-muted">Select what you offer to see your pricing plan</p>
        </div>
      </div>
      <div
        class="flex items-center justify-between rounded-lg p-3 transition-all"
        :class="hasGoldMethods ? 'border-2 border-brand bg-brand-soft' : 'border-2 border-transparent bg-surface-2'"
      >
        <div class="flex items-center space-x-3">
          <span class="material-symbols-outlined" :class="hasGoldMethods ? 'text-brand' : 'text-muted'">diamond</span>
          <span class="text-sm font-semibold" :class="hasGoldMethods ? 'text-brand-soft-text' : 'text-ink'">1:1 Tutoring</span>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-xs text-muted">A weekly one-to-one lesson</span>
          <span v-if="hasGoldMethods" class="material-symbols-outlined text-brand">check_circle</span>
        </div>
      </div>
    </div>
  </section>
</template>
